<template>
    <div class="container">
        <!-- 左侧导航栏 -->
        <NavMenu></NavMenu>
        <!-- 右侧主内容区 -->
        <div class="content-container">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>帖子审核列表</span>
                    <el-button 
                        style=" padding: 3px 0;margin-left: auto;" 
                        type="text" 
                        icon="el-icon-refresh"
                        @click="refresh">
                        刷新
                    </el-button>
                </div>

                <!-- 表格滚动容器 -->
                <div class="table-scroll-wrapper">
                    <el-table
                        :data="postList"
                        border
                        height="73vh"
                        style="width: 100%"
                        v-loading="loading"
                        row-key="id">
                        <el-table-column 
                            prop="id" 
                            label="ID" 
                            width="80"
                            align="center">
                        </el-table-column>
                        <el-table-column 
                            prop="title" 
                            label="标题" 
                            width="200"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column 
                            prop="author" 
                            label="作者" 
                            width="120"
                            align="center">
                        </el-table-column>
                        <el-table-column 
                            prop="content" 
                            label="内容摘要"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column 
                            prop="createTime" 
                            label="发布时间" 
                            width="180"
                            align="center">
                        </el-table-column>
                        <el-table-column 
                            label="状态" 
                            width="120"
                            align="center">
                            <template slot-scope="scope">
                                <el-tag 
                                    :type="scope.row.status | statusTypeFilter"
                                    effect="dark">
                                    {{ scope.row.status }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column 
                            label="操作" 
                            width="240"
                            align="center"
                            fixed="right">
                            <template slot-scope="scope">
                                <el-button-group>
                                    <el-button
                                    size="mini"
                                    type="success"
                                    icon="el-icon-check"
                                    :disabled="scope.row.status !== '待审核'"
                                    @click="handleApprove(scope.row)">
                                    通过
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="danger"
                                    icon="el-icon-close"
                                    :disabled="scope.row.status !== '待审核'"
                                    @click="handleReject(scope.row)">
                                    驳回
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-view"
                                    @click="handleView(scope.row)">
                                    详情
                                </el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="pagination-container">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        :background="true"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </el-card>

            <!-- 审核对话框 -->
            <el-dialog 
                :title="dialogTitle" 
                :visible.sync="dialogVisible" 
                width="500px"
                :close-on-click-modal="false">
                <el-form 
                    :model="auditForm" 
                    label-width="80px"
                    ref="auditForm">
                    <el-form-item 
                        label="审核意见"
                        prop="comment">
                        <el-input
                            type="textarea"
                            :rows="3"
                            v-model="auditForm.comment"
                            placeholder="请输入审核意见（可选）"
                            maxlength="200"
                            show-word-limit>
                        </el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button 
                        type="primary" 
                        @click="submitAudit"
                        :loading="auditLoading">
                        确 定
                    </el-button>
                </span>
            </el-dialog>

            <!-- 查看详情对话框 -->
            <el-dialog 
                title="帖子详情" 
                :visible.sync="viewDialogVisible" 
                width="700px"
                top="5vh">
                <div class="post-detail">
                    <h3 class="post-title">{{ currentPost.title }}</h3>
                    <div class="post-meta">
                        <span><i class="el-icon-user"></i> {{ currentPost.author }}</span>
                        <span style="margin-left: 20px">
                            <i class="el-icon-time"></i> {{ currentPost.createTime }}
                        </span>
                        <el-tag 
                            :type="currentPost.status | statusTypeFilter"
                            style="margin-left: 20px">
                            {{ currentPost.status }}
                        </el-tag>
                    </div>
                    <el-divider></el-divider>
                    <div class="post-content">{{ currentPost.content }}</div>
                    <div class="post-images" v-if="currentPost.images && currentPost.images.length">
                        <el-image 
                            v-for="(img, index) in currentPost.images"
                            :key="index"
                            :src="img"
                            :preview-src-list="currentPost.images"
                            style="width: 150px; height: 150px; margin-right: 10px; margin-bottom: 10px"
                            fit="cover">
                        </el-image>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import NavMenu from '@/components/NavMenu.vue'
export default {
    components:{NavMenu},
    data() {
        return {
            loading: false,
            auditLoading: false,
            currentPage: 1,
            pageSize: 10,
            total: 3,
            dialogVisible: false,
            viewDialogVisible: false,
            dialogTitle: '',
            auditType: '',
            currentPost: {},
            auditForm: {
                postId: null,
                comment: ''
            },
            postList: [
                {
                    id: 1,
                    title: '如何正确给猫咪洗澡？',
                    author: '猫奴小张',
                    content: '分享给猫咪洗澡的详细步骤和注意事项，包括水温控制、洗澡频率、适合的沐浴露选择等...',
                    createTime: '2023-07-20 14:00:23',
                    status: '待审核',
                    images: [
                        'https://dummyimage.com/600x280/4CAF50/fff&text=Cat1',
                        'https://dummyimage.com/600x280/2196F3/fff&text=Cat2'
                    ]
                },
                {
                    id: 2,
                    title: '狗狗饮食健康指南',
                    author: '宠物营养师',
                    content: '详细介绍不同体型、年龄阶段的狗狗饮食搭配方案，包含食材选择、营养配比等专业知识...',
                    createTime: '2023-07-19 10:30:45',
                    status: '已通过',
                    images: []
                },
                {
                    id: 3,
                    title: '仓鼠饲养的十大误区',
                    author: '小宠专家',
                    content: '纠正新手饲养仓鼠常见的错误做法，包括笼子大小、垫材选择、饮食搭配等容易忽视的问题...',
                    createTime: '2023-07-18 15:20:12',
                    status: '待审核',
                    images: [
                        'https://dummyimage.com/600x280/FF9800/fff&text=Hamster'
                    ]
                }
            ]
        }
    },
    filters: {
        statusTypeFilter(status) {
            const typeMap = {
                '待审核': 'warning',
                '已通过': 'success',
                '已驳回': 'danger'
            }
            return typeMap[status] || 'info'
        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchData()
        },
        handleApprove(row) {
            this.auditType = 'approve'
            this.dialogTitle = '通过审核'
            this.auditForm.postId = row.id
            this.currentPost = {...row}
            this.dialogVisible = true
        },
        handleReject(row) {
            this.auditType = 'reject'
            this.dialogTitle = '驳回审核'
            this.auditForm.postId = row.id
            this.currentPost = {...row}
            this.dialogVisible = true
        },
        handleView(row) {
            this.currentPost = { ...row }
            this.viewDialogVisible = true
        },
        submitAudit() {
            this.auditLoading = true
            
            setTimeout(() => {
                this.postList = this.postList.filter(item => item.id !== this.auditForm.postId)
                this.total = this.postList.length
                
                this.$message.success(
                    this.auditType === 'approve' 
                        ? '帖子已通过审核' 
                        : '帖子已驳回'
                )
                
                if (this.auditForm.comment) {
                    this.$notify({
                        title: '审核备注',
                        message: this.auditForm.comment,
                        type: 'info'
                    })
                }
                
                this.dialogVisible = false
                this.auditLoading = false
                this.resetAuditForm()
            }, 800)
        },
        resetAuditForm() {
            this.$refs.auditForm?.resetFields()
            this.auditForm.postId = null
        },
        refresh() {
            this.loading = true
            setTimeout(() => {
                this.loading = false
                this.$message.success('数据已刷新')
            }, 500)
        },
        fetchData() {
            this.loading = true
            setTimeout(() => {
                this.loading = false
            }, 300)
        }
    },
    mounted() {
        this.fetchData()
    }
}
</script>

<style scoped>
::v-deep(.el-card__header) {
    padding: 0;
}
.container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.nav-container {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 280px;
  background-color: #304156;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.nav_menu {
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
}

.content-container {
  flex: 1;
  min-width: 0;
  margin-left: 280px;
  padding: 24px;
  background-color: #f5f7fa;
  min-height: 100vh;
  box-sizing: border-box;
}

.box-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.box-card:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}

.clearfix span {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.table-scroll-wrapper {
  flex: 1;
  overflow-y: auto;
  padding: 0 20px;
  margin: 20px 0;
}

:deep(.el-table) {
  border-radius: 4px;
}

:deep(.el-table th) {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
  height: 48px;
}

:deep(.el-table td) {
  padding: 12px 0;
}

:deep(.el-table--border) {
  border-radius: 4px;
  overflow: hidden;
}

.pagination-container {
  padding: 16px 20px;
  background: #fff;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: flex-end;
}

.post-detail {
  padding: 0 20px;
}

.post-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  line-height: 1.4;
}

.post-meta {
  color: #909399;
  font-size: 14px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.post-meta i {
  margin-right: 4px;
}

.post-content {
  font-size: 14px;
  line-height: 1.8;
  color: #606266;
  margin: 20px 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.post-images {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

:deep(.el-image) {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

:deep(.el-image:hover) {
  transform: translateY(-2px);
}

:deep(.el-button--mini) {
  padding: 7px 12px;
}

:deep(.el-button [class*="el-icon-"] + span) {
  margin-left: 4px;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f5f7fa;
}

::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #c0c4cc;
}

@media screen and (max-width: 1200px) {
  .nav-container {
    width: 220px;
  }
  
  .content-container {
    margin-left: 220px;
  }
}

@media screen and (max-width: 768px) {
  .nav-container {
    display: none;
  }
  
  .content-container {
    margin-left: 0;
    padding: 16px;
  }
  
  .box-card {
    height: auto;
    min-height: calc(100vh - 32px);
  }
  
  .clearfix {
    padding: 12px 16px;
  }
  
  .table-scroll-wrapper {
    padding: 0 16px;
    margin: 16px 0;
  }
  
  .pagination-container {
    padding: 12px 16px;
  }
  
  .post-images {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 12px;
  }
}

:deep(.el-dialog__header) {
  padding: 20px 24px;
  border-bottom: 1px solid #ebeef5;
}

:deep(.el-dialog__body) {
  padding: 24px;
}

:deep(.el-dialog__footer) {
  padding: 16px 24px;
  border-top: 1px solid #ebeef5;
}

:deep(.el-form-item__label) {
  font-weight: 500;
}

:deep(.el-textarea__inner) {
  padding: 8px 12px;
  line-height: 1.6;
}

:deep(.el-tag) {
  border-radius: 4px;
  padding: 0 8px;
  height: 24px;
  line-height: 22px;
}
</style>    